import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { UMPSection } from './components/UMPSection';
import { ProductSection } from './components/ProductSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { RecentPurchaseNotification } from './components/RecentPurchaseNotification';
import { LiveVisitorCounter } from './components/LiveVisitorCounter';
export function App() {
  return <div className="w-full min-h-screen bg-stone-50 font-sans text-gray-900 selection:bg-teal-200 selection:text-teal-900" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Header data-id="element-2" />

      <main data-id="element-3">
        <div className="max-w-7xl mx-auto px-5 md:px-8 mt-6 mb-2" data-id="element-4">
          <LiveVisitorCounter data-id="element-5" />
        </div>

        <HeroSection data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <UMPSection data-id="element-8" />
        <ProductSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <PricingSection data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
      <RecentPurchaseNotification data-id="element-13" />
    </div>;
}